import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { LiveRoomRankMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import masking from '@module/utils/masking';
interface Props {
  fontSizeClass?: string;
  item: LiveRoomRankMessage;
}
export default function LiveRoomRankChat(props) {
  const $ = _c(17);
  const {
    fontSizeClass,
    item
  } = props;
  const {
    message
  } = item.data;
  let t0;
  if ($[0] !== fontSizeClass) {
    t0 = cn("whitespace-pre-wrap rounded-[10px] border-2 border-cht_har_ranking", fontSizeClass);
    $[0] = fontSizeClass;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-full bg-cht_har_ranking text-center leading-[28px]">{"\uD558\uD2B8 \uC120\uBB3C \uB7AD\uD0B9"}</div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== message.opt) {
    t2 = message.opt.map(_temp);
    $[3] = message.opt;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <ul className="py-[5px] pr-[10px] pl-[5px] text-[13px] text-cht_baseFg">{t2}</ul>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t3) {
    t4 = <div className={t0}>{t1}{t3}</div>;
    $[7] = t0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== fontSizeClass) {
    t5 = cn("text-cht_baseFg", fontSizeClass);
    $[10] = fontSizeClass;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <div className={t5}>{"\uD558\uD2B8 \uC120\uBB3C \uB7AD\uD0B9\uC740 1\uBD84\uB9C8\uB2E4 \uAC31\uC2E0\uB429\uB2C8\uB2E4."}</div>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <div className="mb-4">{t4}{t6}</div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(userItem, index) {
  return <li key={userItem.userIdx} className="my-3 flex justify-between"><div className="flex"><div className="w-[20px] text-center">{index + 1}</div><div className="mr-2">{userItem.userNick} ({masking(userItem.userId)})</div></div><div>{`${userItem.totalCoin.toLocaleString()} 개`}</div></li>;
}